module.exports = __webpack_public_path__ + "img/_icon-chevron_nb.1a0507a2.svg";